module.exports = __webpack_public_path__ + "img/slide-17.db7bc0d1.jpeg";